import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FamilyStats from '../components/FamilyStats';
import { parseGedcomToTree } from '../utils/gedcomParser';

const FamilyStatsPage = () => {
  const navigate = useNavigate();
  const [gedcomData, setGedcomData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadGedcomData = async () => {
      try {
        setLoading(true);
        const response = await fetch('/data/rossetti.ged');
        if (!response.ok) {
          throw new Error('Failed to load family data');
        }
        const gedcomText = await response.text();
        const parsedData = parseGedcomToTree(gedcomText);
        setGedcomData(parsedData);
      } catch (err) {
        console.error('Error loading GEDCOM data:', err);
        setError('Failed to load family data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    loadGedcomData();
  }, []);

  const handleViewTree = () => {
    navigate('/family-tree');
  };

  if (loading) {
    return (
      <div className="page-container-wrapper max-width-default padding-default">
        <div className="page-content">
          <div className="loading-container">
            <div className="loading-spinner">
              <i className="fas fa-spinner fa-spin"></i>
            </div>
            <p>Loading family statistics...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container-wrapper max-width-default padding-default">
        <div className="page-content">
          <div className="error-container">
            <div className="error-message">
              <i className="fas fa-exclamation-triangle"></i>
              <h3>Unable to Load Family Data</h3>
              <p>{error}</p>
              <button 
                className="retry-btn" 
                onClick={() => window.location.reload()}
              >
                <i className="fas fa-redo"></i>
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-chart-bar"></i>
          Family Statistics
        </h1>
        <p>Comprehensive insights into the Rossetti family heritage</p>
      </div>
      
      <div className="page-content">
        <FamilyStats 
          gedcomData={gedcomData} 
          onViewTree={handleViewTree} 
        />
      </div>
    </div>
  );
};

export default FamilyStatsPage;